import { render, staticRenderFns } from "./faultsPage.html?vue&type=template&id=3e8e3918&"
import script from "./faultsPage.vue?vue&type=script&lang=js&"
export * from "./faultsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports